import { SOCIALFEED_TOTAL_POST } from "SocialfeedPostAction";


export var SocialfeedTotalPost = (state = {}, action) => {
  
    if (action.type === SOCIALFEED_TOTAL_POST) {
      return action.payload;
    }
    return state;
  }


  
  